import { LoadingButton } from "@mui/lab";
import { useEffect, useRef } from "react";

export default function Mfa({ otp, setOtp, handleSubmintOTP, showOtp, loading, setOpenOtpModal }) {
    const hasSubmittedRef = useRef(false);
    const inputRefs = useRef([]);

    useEffect(() => {
        if (showOtp) {
            setTimeout(() => {
                inputRefs.current[0]?.focus();
            }, 100);
        }
    }, [showOtp]);




    const handleChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input
        if (value && index < 5) {
            // document.getElementById(`otp-${index + 1}`)?.focus();
            inputRefs.current[index + 1]?.focus();

        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];

            if (otp[index]) {
                newOtp[index] = "";
                setOtp(newOtp);
            } else if (index > 0) {
                newOtp[index - 1] = "";
                setOtp(newOtp);
                // document.getElementById(`otp-${index - 1}`)?.focus();
                inputRefs.current[index - 1]?.focus();

            }
        }
    };


    return (
        <div className="fixed inset-0 z-50000 flex items-center justify-center"
        //  style={{
        //     position: "fixed",
        //     inset: 0,
        //     zIndex: 2000,
        //     display: "flex",
        //     justifyContent: "center",
        //     alignItems: "center"
        // }}
        >
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />

            {/* Modal */}
            <div className="relative w-full max-w-sm mx-4 bg-white rounded-xl shadow-xl border border-border-light">
                <div className={`grid grid-cols-1 divide-y md:divide-y-0 md:divide-x divide-border-light`}>

                    {/* Close button */}
                    <button
                        onClick={() => setOpenOtpModal(false)}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                    >
                        ✕
                    </button>

                    {/* OTP SECTION */}
                    {showOtp && (
                        <div className="p-6 flex flex-col">
                            <h3 className="text-xl font-bold mb-2">One-Time Password</h3>
                            <p className="text-slate-500 text-sm mb-8">
                                Enter the 6-digit verification code.
                            </p>

                            <fieldset className="flex justify-center gap-2 mb-8">
                                {otp?.map((digit, index) => (
                                    <input
                                        key={index}
                                        disabled={loading}
                                        id={`otp-${index}`}
                                        ref={(el) => (inputRefs.current[index] = el)}

                                        type="text"
                                        inputMode="numeric"
                                        maxLength={1}
                                        value={digit}
                                        onChange={(e) => handleChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        // className="h-14 w-10 text-center text-2xl font-bold rounded-lg bg-gray-50 border-2 border-border-light focus:border-primary outline-none transition-all"
                                        className="h-14 w-10 text-center text-2xl font-bold rounded-lg bg-gray-50 border-2 border-gray-300 focus:border-black focus:ring-2 focus:ring-black/20 outline-none transition-all caret-black"

                                    />
                                ))}
                            </fieldset>

                            <div className="flex justify-center">
                                <LoadingButton
                                    loading={loading}
                                    disabled={loading}
                                    variant={loading ? "outlined" : "contained"}
                                    onClick={handleSubmintOTP}
                                >
                                    Verify OTP
                                </LoadingButton>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
